import { reactive, ref, computed, watch } from '@vue/composition-api'
import * as apiQA from '@/api/qa'

/**
 * 書籍選択ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    choices_packages: computed(() => {
      return props.parentGroup1.choices_packages
    }),

    package_ids: computed({
      get: () => {
        return props.parentGroup1.package_ids
      },
      set: (packageIds) => {
        props.parentGroup1.package_ids = packageIds
      }
    }),

    /**
     * 決定ボタンを押下した時
     */
    submit: () => {
      context.parent.group1.package_ids = group1.package_ids

      context.emit('closeSearchDetailPackageList')
    }
    
  })

  return group1
}
